import React from 'react';
import { ImportSource } from '../../graphql/generated/graphql';
import ImportFileModal from './ImportFileModal';

interface NotionImportModalProps {
  accept?: string;
  close: () => void;
}

const NotionImportModal = (props: NotionImportModalProps) => (
  <ImportFileModal
    {...props}
    source={ImportSource.Notion}
    uploaderSubject="the zip file from Notion's HTML export"
    footer={
      <a
        href="https://go.slab.com/importing-all-your-content-from-notion"
        rel="noopener noreferrer"
        target="_blank"
      >
        How do I export from Notion?
      </a>
    }
  />
);

export default NotionImportModal;
